import * as React from 'react';
import PropTypes from 'prop-types';

import update from 'immutability-helper';

const nowTime = () => new Date().getTime();

const propTypes = {
  time: PropTypes.number,
  before: PropTypes.string,
  plan: PropTypes.string,
};

const defaultProps = {
  time: 0,
  before: '',
  plan: 'A_1day',
};

// 일: 日
// 시간: 時間
// 분 : 分

const unitM = 1000 * 60;
const unitH = unitM * 60;
const unitD = unitH * 24;

function toDateString(time) {
  if (time >= unitD) {
    return `${Math.ceil(time / unitD)}일`;
  }
  if (time >= unitH) {
    return `${Math.ceil(time / unitH)}시간`;
  }
  return `${Math.ceil(time / unitM)}분`;
}

function isPeriodRemainRed(plan, time) {
  const planDay = plan.replace(/[^0-9]/g, '');
  if (parseInt(planDay, 10) <= 30 && Math.ceil(time / unitD) <= 10) {
    return true;
  }
  if (parseInt(planDay, 10) > 30 && Math.ceil(time / unitD) <= 30) {
    return true;
  }
  return false;
}

// 플레이어 하단에 기간이 얼마남았는지 보여지는 것
class Timer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      time: '',
      isRed: false,
    };
    this.startTimer = this.startTimer.bind(this);
    this.stopTimer = this.stopTimer.bind(this);
  }

  componentDidMount() {
    this.startTimer();
  }

  componentWillUnmount() {
    this.stopTimer();
  }

  startTimer() {
    this.timer = setInterval(() => {
      const { time, plan } = this.props;
      const newChar = toDateString(time - nowTime());
      if (time !== newChar) {
        this.setState(
          update(this.state, {
            time: { $set: newChar },
            isRed: { $set: isPeriodRemainRed(plan, time - nowTime()) },
          }),
        );
      }
    }, 1000);
  }

  stopTimer() {
    clearInterval(this.timer);
    delete this.timer;
  }

  render() {
    const { before } = this.props;
    const { time, isRed } = this.state;
    let infoColor = {};
    if (isRed) {
      infoColor = { color: 'red' };
    } else {
      infoColor = {};
    }
    return (
      <div className="info" style={infoColor}>
        {`${time !== '' ? before : ''}${time}`}
      </div>
    );
  }
}

Timer.propTypes = propTypes;
Timer.defaultProps = defaultProps;

export default Timer;
